import Metas from '@/views/admin/metas'
import MetaSave from '@/views/admin/metas/Save'

export const metas = [
  {
    path: 'metas/list',
    component: Metas,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  },
  {
    name: 'admin_metas_save',
    path: 'metas/save/:id?',
    component: MetaSave,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/metas.js